import React from 'react';
import PropTypes from 'prop-types';

const CardWithRadioButtons = ({
  imageUrl,
  options,
  onChange,
  selectedPart
}) => {
  return (
    <div className="card-radio">
      <img src={imageUrl} alt="" className="card-radio_img" />
      <div className="card-radio_options">
        {options &&
          options.map((option, index) => (
            <div className="card-radio_option">
              <input
                type="radio"
                id={option.partId}
                name={option.configData.label}
                className="card-radio_option_input"
                checked={
                  (selectedPart && selectedPart === option.partId) ||
                  (!selectedPart && !option.partId)
                }
                onChange={() => onChange(index)}
              />
              <label className="card-radio_circle" htmlFor={option.partId} />
              <div className="card-radio_option_label">
                {option.configData.label}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

CardWithRadioButtons.propTypes = {
  imageUrl: PropTypes.string,
  icon: PropTypes.string,
  oprions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      value: PropTypes.string,
      label: PropTypes.string,
      checked: PropTypes.bool
    })
  )
};

export default CardWithRadioButtons;
